import type { ReactNode } from 'react'

import { PageContainer } from '@/components/ui/page-container'
import { PageHeader } from '@/components/ui/page-header'
import { cn } from '@/lib/utils'

export type SettingsPageShellProps = {
  title: string
  description?: string
  children: ReactNode
  /** Sits on the right of the page title. */
  actions?: ReactNode
  /** `wide` fits a plan comparison. Other settings stay on the 640px column. */
  layout?: 'default' | 'wide'
}

/** Settings-class page chrome: container, 640px column, `PageHeader size="settings"`. */
export function SettingsPageShell({
  title,
  description,
  children,
  actions,
  layout = 'default',
}: SettingsPageShellProps) {
  const wide = layout === 'wide'
  return (
    <PageContainer maxWidth={wide ? '6xl' : '4xl'} className="py-10">
      <div className={cn('mx-auto w-full space-y-6', wide ? 'max-w-6xl' : 'max-w-[640px]')}>
        <PageHeader size="settings" title={title} description={description} actions={actions} />
        {children}
      </div>
    </PageContainer>
  )
}
